<template>
    <div class="container">
        <div class="device" @click="clickMeNow" :style="{ top: deviceTop }">
            <div class="window mobile-device">
                <div class="body-area" :style="{ width: deviceWidth + 'px', height: deviceHeight + 'px' }">
                    <div class="body" :style="{ width: deviceWidth + 'px', height: deviceHeight + 'px' }">
                        <div v-if="deviceMessage && !error" class="message"> {{ deviceMessage }}</div>
                        <div v-if="error" class="message"
                            style="display: flex;flex-direction: column;align-items: center;width: 100%"
                            @click.stop="openPlayer">
                            <div style="padding-bottom: 40px">{{ deviceMessage }}</div>
                            <i class="el-icon-refresh" style="font-size: 40px"></i>
                            <div>点击刷新推流</div>
                        </div>
                        <div id="target" :style="{ width: deviceWidth + 'px', height: deviceHeight + 'px' }">
                        </div>
                    </div>
                </div>

                <div class="footer" :style="{ width: deviceWidth + 'px' }">
                    <el-tooltip class="tooltip" effect="dark" content="返回键" placement="top-start">
                        <div class="return" @click.stop="returnClick"></div>
                    </el-tooltip>
                    <el-tooltip class="tooltip" effect="dark" content="主页键" placement="top">
                        <div class="home" @click.stop="homeClick"></div>
                    </el-tooltip>
                    <!-- <el-tooltip class="tooltip" effect="dark" content="截图" placement="top">
                        <div class="snapshot" @click.stop="snapshotClick"></div>
                    </el-tooltip> -->
                    <el-tooltip class="tooltip" effect="dark" content="任务键" placement="top">
                        <div class="recent" @click.stop="recentClick"></div>
                    </el-tooltip>
                    <el-tooltip class="tooltip" effect="dark" content="音量+" placement="top">
                        <div class="vol-up" @click.stop="volUpClick"></div>
                    </el-tooltip>
                    <el-tooltip class="tooltip" effect="dark" content="音量-" placement="top">
                        <div class="vol-down" @click.stop="volDownClick"></div>
                    </el-tooltip>
                    <!-- <el-tooltip class="tooltip" effect="dark" content="切换横竖屏" placement="top">
                        <div class="toogle-orientation" @click.stop="toogleOrientationClick"></div>
                    </el-tooltip> -->
                    <el-tooltip class="tooltip" effect="dark" content="关闭推流" placement="top-end">
                        <div class="close-stream" @click.stop="closeClick"></div>
                    </el-tooltip>
                </div>
            </div>

            <!-- <el-dialog title="设备截图" :visible.sync="dialogVisible" :modal="false" :append-to-body="true" width="30%">
                <div style="display: flex;flex-direction: column;">
                    <el-image v-if="url" style="width: 100%;" :src="url" fit="cover"></el-image>
                    <el-button type="primary" size="medium" style="margin: 10px 0" @click.stop="downloadPng">下载图片
                    </el-button>
                    <span style="font-size: 12px;color: red">如无法下载，可右键-图片另存为(图片已默认保存至云机相册内)</span>
                </div>
            </el-dialog> -->
        </div>
    </div>
</template>

<script>

export default {
    name: "DeviceWindowMobile",
    props: {
        id: Number,

        remark: String,
        deviceId: Number,
        appid: {
            type: String,
            default: "0"
        },
        ip: String,
        engineType: Number
    },
    data() {
        return {
            myDomain: "",
            appkey: 'ffffccec3c124642967fe476cef558c4',
            requestUrl: '/mosico/player/bootstrap',
            reportUrl: '/mosico/player/terminate',
            player: null,
            deviceWidth: 333,
            deviceHeight: 592,
            deviceMessage: "",
            dialogVisible: false,
            url: '',
            status: false,
            many: false,
            left: 0,
            top: 0,
            error: false,
            resizeTimer: null,
            // 浏览器特性检测
            hasStatusBar: false,
            hasBottomSafeArea: false,
            safeAreaInsets: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            },
            // 组件移动状态
            deviceTop: "0px",
            originalTop: "0px",
            keyboardHeight: 0,
            isDeviceMoved: false,
            showKeyboard: false,
            // 触摸坐标记录
            touchY: 0,
            // 防抖动计时器
            focusInTimeout: null,
            focusOutTimeout: null
        }
    },

    mounted() {
        // console.log("locale " + this.localeList[0].split("-")[0] + "-" + this.localeList[0].split("-")[1])
        this.myDomain = document.domain ? document.domain : window.location.hostname
        if (this.myDomain == "127.0.0.1") {
            this.myDomain = this.$store.getters.shinoIp()
        }
        // console.log(this.$store.state.orekiIp+"/" + this.$store.state.webIp)
        console.log("myDomain is " + this.myDomain)

        // 检测浏览器特性
        this.detectBrowserFeatures();

        // 根据窗口大小计算设备宽高，保持9:16宽高比
        this.calculateDeviceSize();

        LongeneClient.LoggingControl.setLogLevel('info');
        let phoneShow = false
        if (this.engineType === 21 || this.engineType === 17 || this.engineType === 22 || this.engineType === 23 || this.engineType === 24 || this.engineType === 32) {
            phoneShow = true
        }

        this.player = LongeneClient.createAppPlayer('target', {
            keyboard: true,
            orientation: 'portrait',
            phoneShow: phoneShow
            // enableRemoteCamera: true
        });

        this.player.on('error', (error) => {
            if (error && error.message && error.code) {
                this.error = true
                this.deviceMessage = error.message + '(' + error.code + ')';
            }
        })
        this.deviceMessage = '正在连接中...';
        this.player.on('statechange', () => {
            if (this.player.state == 'playing') {
                this.deviceMessage = '';
                this.status = true
            }
        })
        this.player.on('networkinfo', network => {
            // console.log(network)
        })

        // 添加键盘事件监听
        this.setupKeyboardListeners();
        if (this.ip) {
            this.openPlayer()
        }
    },
    beforeDestroy() {
        this.player.close();
        if (this.cpuTimer) {
            clearInterval(this.cpuTimer)
            this.cpuTimer = null
        }
        // 清理键盘事件监听
        this.cleanupKeyboardListeners();
    },
    filters: {
        localeValue(item) {
            return item.split("-")[0] + "-" + item.split("-")[1]
        },
        timeZoneValue(item) {
            return item.split("-")[0]
        }
    },

    methods: {
        // 检测浏览器特性（状态栏、安全区域等）
        detectBrowserFeatures() {
            const clientHeight = document.documentElement.clientHeight;
            const innerHeight = window.innerHeight;

            // 检测是否为iOS设备
            // const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            const isIOS = false
            // 检测状态栏：通过比较clientHeight和innerHeight
            // 如果有状态栏，innerHeight通常小于clientHeight
            this.hasStatusBar = innerHeight < clientHeight;

            // 检测CSS环境变量支持
            const supportsSafeArea = CSS.supports('padding-top', 'env(safe-area-inset-top)');

            if (supportsSafeArea) {
                // 尝试获取安全区域值
                const testDiv = document.createElement('div');
                testDiv.style.paddingTop = 'env(safe-area-inset-top)';
                document.body.appendChild(testDiv);

                // 通过计算样式检测安全区域
                const computedStyle = window.getComputedStyle(testDiv);
                const safeAreaTop = computedStyle.paddingTop;

                // 如果安全区域值不是0，说明有安全区域
                this.hasBottomSafeArea = safeAreaTop !== '0px';

                document.body.removeChild(testDiv);

                // 记录安全区域值（如果可用）
                if (this.hasBottomSafeArea) {
                    console.log('检测到安全区域支持');
                }
            } else {
                // 不支持CSS环境变量，使用启发式检测
                // iOS设备通常有底部安全区域，特别是iPhone X及以后机型
                this.hasBottomSafeArea = isIOS || (clientHeight > 700);
            }

            // 对于iOS设备，特别处理底部安全区域
            if (isIOS) {
                // iOS设备通常有较大的底部安全区域
                this.hasBottomSafeArea = true;

                // 检测是否为iPhone X及以后机型（有刘海屏）
                const isIPhoneXOrLater = /iPhone X|iPhone 1[1-9]|iPhone [2-9][0-9]/.test(navigator.userAgent) ||
                    (window.screen.height >= 812 && window.screen.width >= 375);

                if (isIPhoneXOrLater) {
                    // iPhone X及以后机型有更大的底部安全区域
                    this.iosBottomSafeArea = Math.min(88, Math.floor(clientHeight * 0.15));
                } else {
                    // 早期iOS设备底部安全区域较小
                    this.iosBottomSafeArea = Math.min(34, Math.floor(clientHeight * 0.08));
                }
            }

            // 设置CSS变量回退值
            this.setSafeAreaCSSVariables();

            console.log(`浏览器特性检测: iOS=${isIOS}, 状态栏=${this.hasStatusBar}, 底部安全区域=${this.hasBottomSafeArea}, clientHeight=${clientHeight}, innerHeight=${innerHeight}`);
        },

        // 设置CSS变量作为安全区域回退机制
        setSafeAreaCSSVariables() {
            const clientHeight = document.documentElement.clientHeight;
            const clientWidth = document.documentElement.clientWidth;

            // 计算安全区域值
            let topInset = 0;
            let bottomInset = 0;
            let leftInset = 0;
            let rightInset = 0;

            if (this.hasStatusBar) {
                // 有状态栏：使用实际差值或默认值
                topInset = Math.max(20, clientHeight - window.innerHeight);
                topInset = Math.min(topInset, 44); // 最大44px
            }

            if (this.hasBottomSafeArea) {
                // 有底部安全区域：使用较大值
                bottomInset = Math.min(88, Math.floor(clientHeight * 0.12));
            } else {
                // 无底部安全区域：使用较小值
                bottomInset = clientHeight > 700 ? Math.min(34, Math.floor(clientHeight * 0.05)) : 0;
            }

            // 横向安全区域（考虑屏幕边缘）
            leftInset = Math.min(10, Math.floor(clientWidth * 0.03));
            rightInset = Math.min(10, Math.floor(clientWidth * 0.03));

            // 设置CSS变量
            const root = document.documentElement;
            root.style.setProperty('--safe-area-inset-top', `${topInset}px`);
            root.style.setProperty('--safe-area-inset-bottom', `${bottomInset}px`);
            root.style.setProperty('--safe-area-inset-left', `${leftInset}px`);
            root.style.setProperty('--safe-area-inset-right', `${rightInset}px`);

            console.log('CSS安全区域变量设置:', {
                top: topInset,
                bottom: bottomInset,
                left: leftInset,
                right: rightInset
            });
        },

        // 计算设备尺寸，保持9:16宽高比，优化移动端适配
        calculateDeviceSize() {
            // 获取视口尺寸，考虑移动端安全区域
            const clientWidth = document.documentElement.clientWidth;
            const clientHeight = document.documentElement.clientHeight;
            const innerHeight = window.innerHeight;

            // 检测是否为iOS设备
            // const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            const isIOS = false
            // 计算移动端安全区域（根据检测结果动态调整）
            let safeAreaHeight = clientHeight;
            let safeAreaWidth = clientWidth;

            // 根据检测结果动态调整安全区域
            let statusBarHeight = 0;
            let bottomSafeArea = 0;

            // 状态栏高度调整
            if (this.hasStatusBar) {
                // 有状态栏：使用实际差值或默认值
                statusBarHeight = Math.max(20, clientHeight - innerHeight);
                statusBarHeight = Math.min(statusBarHeight, 44); // 最大44px
            } else {
                // 无状态栏：使用较小边距
                statusBarHeight = Math.min(10, Math.floor(clientHeight * 0.02));
            }

            // 底部安全区域调整
            if (this.hasBottomSafeArea) {
                // 有底部安全区域：使用较大值
                if (isIOS && this.iosBottomSafeArea) {
                    // iOS设备使用特定的底部安全区域值
                    bottomSafeArea = this.iosBottomSafeArea;
                } else {
                    bottomSafeArea = Math.min(88, Math.floor(clientHeight * 0.12));
                }
            } else {
                // 无底部安全区域：使用较小值或根据屏幕高度判断
                bottomSafeArea = clientHeight > 700 ? Math.min(34, Math.floor(clientHeight * 0.05)) : 0;
            }

            safeAreaHeight = clientHeight - statusBarHeight - bottomSafeArea;
            safeAreaWidth = clientWidth
            // 根据9:16宽高比计算最大可用尺寸
            const widthByHeight = Math.floor(safeAreaHeight * 9 / 16);
            const heightByWidth = Math.floor(safeAreaWidth * 16 / 9);

            // 选择最优尺寸：优先保证完全显示在安全区域内
            if (widthByHeight <= safeAreaWidth) {
                // 按高度计算宽度不超过安全宽度，使用高度优先
                this.deviceHeight = safeAreaHeight;
                this.deviceWidth = widthByHeight;
            } else if (heightByWidth <= safeAreaHeight) {
                // 按宽度计算高度不超过安全高度，使用宽度优先
                this.deviceWidth = safeAreaWidth;
                this.deviceHeight = heightByWidth;
            } else {
                // 两者都超出，选择较小的缩放比例
                const scaleByWidth = safeAreaWidth / (safeAreaHeight * 9 / 16);
                const scaleByHeight = safeAreaHeight / (safeAreaWidth * 16 / 9);

                if (scaleByWidth >= scaleByHeight) {
                    this.deviceWidth = safeAreaWidth;
                    this.deviceHeight = Math.floor(safeAreaWidth * 16 / 9);
                } else {
                    this.deviceHeight = safeAreaHeight;
                    this.deviceWidth = Math.floor(safeAreaHeight * 9 / 16);
                }
            }

            // 确保最小尺寸
            const minWidth = 240;
            const minHeight = Math.floor(minWidth * 16 / 9);

            if (this.deviceWidth < minWidth) {
                this.deviceWidth = minWidth;
                this.deviceHeight = minHeight;
            }

            if (this.deviceHeight < minHeight) {
                this.deviceHeight = minHeight;
                this.deviceWidth = Math.floor(this.deviceHeight * 9 / 16);
            }

            // 居中定位
            this.left = Math.max(0, (clientWidth - this.deviceWidth) / 2);

            // 优化移动端居中算法（去掉header后）
            if (isIOS) {
                // iOS设备：考虑状态栏和底部安全区域，确保内容完全可见
                const statusBarHeight = this.hasStatusBar ? Math.max(20, clientHeight - innerHeight) : 0;

                this.top = statusBarHeight

            } else {

                this.top = 0
            }

            console.log(`设备尺寸: ${this.deviceWidth}x${this.deviceHeight}, 窗口尺寸: ${clientWidth}x${clientHeight}, 安全区域: ${safeAreaWidth}x${safeAreaHeight}, iOS: ${isIOS}, 位置: ${this.left}x${this.top}`);
        },


        clickMeNow() {
            // console.log("click me id " + this.id)
            this.$store.commit(this.$mutation.DEVICE_WINDOW_SHOW_LATEST, this.id)
        },
        checkLicenseService(index) {
            let found = -1
            if (this.$store.state.licenseInfo && this.$store.state.licenseInfo.service) {
                let serviceItems = this.$store.state.licenseInfo.service.toString().split(",")
                serviceItems.forEach(item => {
                    // console.log("item is " + item + ", index is " + index)
                    if (item == index) {
                        found = 1
                        return
                    }
                })
            }
            return found
        },

        openPlayer() {
            this.deviceMessage = '连接中...'
            this.error = false
            let shinoIp = this.$store.getters.shinoIp();
            let that = this;
            // console.log("deviceNo is " + deviceNo)
            this.$post(this.$uri.device.getFlowDeviceId, { deviceIp: this.ip }).then(res => {
                // console.log("res is " + JSON.stringify(res));
                if (res.success && res.data) {
                    let flowDeviceId = res.data
                    this.player.open({
                        localMediaOpen: true,
                        appkey: this.appkey,
                        appid: this.appid,
                        ljyip: shinoIp,
                        domain_name: this.myDomain,
                        domain: this.myDomain,
                        deviceId: flowDeviceId,
                        requestUrl: window.location.host + '/' + this.requestUrl,
                        reportUrl: window.location.host + '/' + this.reportUrl
                    });
                } else {
                    this.player.open({
                        localMediaOpen: true,
                        appkey: this.appkey,
                        appid: this.appid,
                        ljyip: shinoIp,
                        domain_name: this.myDomain,
                        domain: this.myDomain,
                        deviceId: this.deviceId,
                        requestUrl: window.location.host + '/' + this.requestUrl,
                        reportUrl: window.location.host + '/' + this.reportUrl
                    });
                }
                setTimeout(() => {
                    that.player.updateInterface();
                }, 50)
            });
        },

        // downloadPng() {
        //     let downloadHref = '/snapshot/' + this.deviceId + '.png?temp=' + Math.random()
        //     let filename = this.deviceId + '.png'
        //     let a = document.createElement('a')
        //     a.href = downloadHref
        //     a.download = filename
        //     a.click()
        // },

        closeClick() {
            console.log("closeClick")
            if (this.player) {
                this.player.close();
            }
            this.$emit('close')
        },

        returnClick() {
            if (this.player) {
                this.player.emitBack();
            }
        },

        homeClick() {
            if (this.player) {
                this.player.emitHome();
            }
        },
        // snapshotClick() {
        //     let that = this
        //     that.$post(that.$uri.device.snapshot, { deviceIp: that.ip, isSave: 1, isRetImg: 1 }).then(res => {
        //         that.url = res.data
        //         that.dialogVisible = true
        //     })
        // },

        recentClick() {
            if (this.player) {
                this.player.openRecent();
            }
        },

        volUpClick() {
            if (this.player) {
                this.player.emitVolumeUp();
            }
        },

        volDownClick() {
            if (this.player) {
                this.player.emitVolumeDown();
            }
        },

        // toogleOrientationClick() {
        //     if (this.player) {
        //         let width = this.deviceWidth;
        //         this.deviceWidth = this.deviceHeight;
        //         this.deviceHeight = width;
        //         // console.log("deviceWidth " + this.deviceWidth)
        //         // console.log("deviceHeight " + this.deviceHeight)
        //         let orientation = this.player.orientation;
        //         if (orientation == 'portrait') {
        //             this.player.setOrientation('landscape');
        //         } else {
        //             this.player.setOrientation('portrait');
        //         }

        //         setTimeout(() => {
        //             this.player.updateInterface();
        //         }, 50)
        //     }
        // },

        // 设置键盘事件监听
        setupKeyboardListeners() {
            // 监听触摸事件，记录触摸坐标
            document.addEventListener('touchstart', this.handleTouchStart);

            // 监听焦点变化（输入框获得/失去焦点）
            document.addEventListener('focusin', this.handleFocusIn);
            document.addEventListener('focusout', this.handleFocusOut);
        },

        // 清理键盘事件监听
        cleanupKeyboardListeners() {
            document.removeEventListener('touchstart', this.handleTouchStart);

            document.removeEventListener('focusin', this.handleFocusIn);
            document.removeEventListener('focusout', this.handleFocusOut);
        },


        // 处理触摸开始事件，记录触摸坐标
        handleTouchStart(event) {
            if (event.touches && event.touches.length > 0) {
                const touch = event.touches[0];
                this.touchY = touch.clientY;
                console.log('触摸开始，Y坐标:', this.touchY);
            }
        },

        // 处理输入框获得焦点
        handleFocusIn(event) {
            // 防抖动处理
            if (this.focusInTimeout) {
                clearTimeout(this.focusInTimeout);
            }
             this.focusInTimeout = setTimeout(() => {
                const target = event.target;
                let that = this

                if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
                   
                    // 移动device组件到键盘上方
                    if (!this.showKeyboard) {
                        this.showKeyboard = true
                        setTimeout(() => {
                            that.moveDeviceUpForKeyboard();
                        }, 300)
                    }
                }
            }, 100); // 100ms防抖动延迟
        },

        // 处理输入框失去焦点
        handleFocusOut(event) {
            // 防抖动处理
            if (this.focusOutTimeout) {
                clearTimeout(this.focusOutTimeout);
            }

            this.focusOutTimeout = setTimeout(() => {
                const target = event.target;

                if ((target.tagName === 'INPUT' || target.tagName === 'TEXTAREA')) {
                    // this.$message.error("失去焦点：" + target.tagName)
                    // 恢复device组件到原来位置
                    if (this.showKeyboard) {
                        this.showKeyboard = false
                        this.restoreDevicePosition();
                    }
                }
            }, 100); // 100ms防抖动延迟
        },

        // 移动device组件到键盘上方
        moveDeviceUpForKeyboard() {
            if (this.isDeviceMoved) {
                return; // 如果已经移动过，不再重复移动
            }

            // 优化键盘高度计算逻辑
            const keyboardHeight = this.calculateKeyboardHeight();

            // 判断触摸位置是否高于键盘高度
            // 使用屏幕可用高度而不是当前视口高度
            const screenHeight = window.screen.availHeight || window.innerHeight;
            // 正确计算触摸点到屏幕底部的距离
            const touchPositionFromBottom = screenHeight - this.touchY;

            // this.$message.info('触摸位置判断:'+
            //     '\ntouchY:' + this.touchY + 
            //     '\nscreenHeight:' + screenHeight + 
            //     '\ninnerHeight:' + window.innerHeight +
            //     '\ntouchPositionFromBottom:'+ touchPositionFromBottom+
            //     '\nkeyboardHeight:' + keyboardHeight
            // );

            // 如果触摸位置高于键盘高度（即不会被键盘覆盖），则不移动组件
            if (touchPositionFromBottom > keyboardHeight) {
                console.log('触摸位置高于键盘高度，不需要移动Device组件');
                return;
            }

            if (keyboardHeight > 0) {
                // 保存原始位置
                this.originalTop = this.deviceTop;
                this.keyboardHeight = keyboardHeight;

                // 应用上移，使用top属性
                this.deviceTop = `-${keyboardHeight}px`;
                this.isDeviceMoved = true;

                console.log('Device组件已上移', keyboardHeight, 'px');
            }
           
        },

        // 计算键盘高度
        calculateKeyboardHeight() {
            // 检测是否为iOS设备
            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

            // 如果是iOS手机，键盘高度设置为350，否则就是300
            const keyboardHeight = isIOS ? 330 : 300;

            console.log('键盘高度设置:', {
                isIOS: isIOS,
                keyboardHeight: keyboardHeight
            });

            return keyboardHeight;
        },

        // 恢复device组件到原来位置
        restoreDevicePosition() {
            if (!this.isDeviceMoved) {
                return; // 如果没有移动过，不需要恢复
            }

            // 恢复原始位置，使用top属性
            this.deviceTop = this.originalTop;
            this.isDeviceMoved = false;

            console.log('Device组件已恢复原位');
        }
    }
};
</script>

<style lang="less" scoped>
.container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #111;
    z-index: 1000;
}

.device {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2000;
    pointer-events: none;
    background-color: #111;
    display: flex;
    align-items: flex-start;
    justify-content: center;

    /* 确保device容器组件能够响应transform变换 */
    will-change: transform;

    /* 移动端视口适配 */
    @media (max-width: 768px) {
        /* 确保在移动端完全覆盖视口 */
        width: 100vw;
        height: 100vh;

        /* 移动端安全区域适配，支持回退机制 */
        padding: var(--safe-area-inset-top, 0px) var(--safe-area-inset-right, 0px) var(--safe-area-inset-bottom, 0px) var(--safe-area-inset-left, 0px);
        padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);
    }

    .window {
        pointer-events: visible;

        // background-color: red;
        /* 移动端优化样式 */
        &.mobile-device {
            position: relative;
            will-change: transform;

            /* 移动端响应式字体 */
            font-size: 14px;

            .body-area {
                /* 确保body区域正确显示 */
                overflow: hidden;
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;

                /* 确保body-area组件能够响应transform变换 */
                position: relative;
                will-change: transform;

                .body {
                    /* 移动端body优化 */
                    background: #000;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .message {
                        /* 移动端消息样式优化 */
                        font-size: 14px;
                        padding: 10px;
                        text-align: center;
                    }
                }
            }

            .footer {
                /* 移动端底部按钮优化 */
                height: 36px;
                min-height: 36px;
                display: flex;
                align-items: center;
                justify-content: space-around;
                background: #111;

                @media (max-width: 480px) {
                    height: 32px;
                    min-height: 32px;

                    &>div {
                        width: 24px;
                        height: 24px;
                    }
                }
            }
        }

        .body-area {
            position: relative;
            display: flex;
            flex-direction: row;
        }

        .body {
            position: relative;
            background: #000;

            .message {
                position: absolute;
                color: #fff;
                top: 50%;
                left: 50%;
                z-index: 1;
                transform: translate(-50%, -50%);
            }
        }


        .footer {
            background: #111;
            height: 36px;
            display: flex;
            justify-content: space-around;
            align-items: center;

            &>div {
                width: 24px;
                height: 24px;
                cursor: pointer;
            }

            .return {
                background: url('../assets/i_back.png') no-repeat;
                background-size: 100% 100%;
            }

            // .snapshot {
            //     background: url('../assets/i_jt.png') no-repeat;
            //     background-size: 100% 100%;
            // }

            .home {
                background: url('../assets/i_home.png') no-repeat;
                background-size: 100% 100%;
            }

            .recent {
                background: url('../assets/i_drw.png') no-repeat;
                background-size: 100% 100%;
            }

            .vol-up {
                background: url('../assets/i_ya.png') no-repeat;
                background-size: 100% 100%;
            }

            .vol-down {
                background: url('../assets/i_ys.png') no-repeat;
                background-size: 100% 100%;
            }

            // .toogle-orientation {
            //     background: url('../assets/i_hsp.png') no-repeat;
            //     background-size: 100% 100%;
            // }

            .close-stream {
                background: url('../assets/close.png') no-repeat;
                background-size: 100% 100%;
            }
        }
    }

    /* 键盘弹出提醒消息样式 */
    .keyboard-notification {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 3000;
        pointer-events: none;
        animation: keyboardNotificationFadeIn 0.3s ease-in-out;

        .keyboard-notification-content {
            background: rgba(0, 0, 0, 0.8);
            color: #fff;
            padding: 12px 20px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 14px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255, 255, 255, 0.1);

            i {
                font-size: 16px;
                color: #ffc107;
            }

            span {
                font-weight: 500;
            }
        }

        /* 移动端优化 */
        @media (max-width: 768px) {
            .keyboard-notification-content {
                padding: 10px 16px;
                font-size: 13px;

                i {
                    font-size: 14px;
                }
            }
        }

        @media (max-width: 480px) {
            .keyboard-notification-content {
                padding: 8px 12px;
                font-size: 12px;
                gap: 6px;
            }
        }
    }

    /* 动画效果 */
    @keyframes keyboardNotificationFadeIn {
        0% {
            opacity: 0;
            transform: translate(-50%, -40%);
        }

        100% {
            opacity: 1;
            transform: translate(-50%, -50%);
        }
    }

    @keyframes keyboardNotificationFadeOut {
        0% {
            opacity: 1;
            transform: translate(-50%, -50%);
        }

        100% {
            opacity: 0;
            transform: translate(-50%, -60%);
        }
    }
}
</style>
